/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyInvite } from './CompanyInvite';
import {
    CompanyInviteFromJSON,
    CompanyInviteFromJSONTyped,
    CompanyInviteToJSON,
    CompanyInviteToJSONTyped,
} from './CompanyInvite';

/**
 * List of pending invitations for a company
 * @export
 * @interface ListPendingInvitesResponse
 */
export interface ListPendingInvitesResponse {
    /**
     * 
     * @type {Array<CompanyInvite>}
     * @memberof ListPendingInvitesResponse
     */
    invites: Array<CompanyInvite>;
}

/**
 * Check if a given object implements the ListPendingInvitesResponse interface.
 */
export function instanceOfListPendingInvitesResponse(value: object): value is ListPendingInvitesResponse {
    if (!('invites' in value) || value['invites'] === undefined) return false;
    return true;
}

export function ListPendingInvitesResponseFromJSON(json: any): ListPendingInvitesResponse {
    return ListPendingInvitesResponseFromJSONTyped(json, false);
}

export function ListPendingInvitesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPendingInvitesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invites': ((json['invites'] as Array<any>).map(CompanyInviteFromJSON)),
    };
}

export function ListPendingInvitesResponseToJSON(json: any): ListPendingInvitesResponse {
    return ListPendingInvitesResponseToJSONTyped(json, false);
}

export function ListPendingInvitesResponseToJSONTyped(value?: ListPendingInvitesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invites': ((value['invites'] as Array<any>).map(CompanyInviteToJSON)),
    };
}

